const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://rwwh80chgb.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://n1a9gp9mng.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://mcg4gxt6y1.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.valeglobal.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.valeglobal.forwoodsafety.com',
    WEBSOCKET: 'wss://opv2fciaaf.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;